import { environment } from 'src/environments/environment'
import { defaultLegacyImageProcessorOptions, ILegacyImageProcessorOptions } from '../interfaces/image.interface'
import { isValidUrl } from './string.util'

export const buildImageSrc = (imageData: string | string[] | undefined, options: ILegacyImageProcessorOptions): string => {
  if (Array.isArray(imageData)) {
    imageData = imageData[0]
  }
  if (imageData && isValidUrl(imageData)) {
    return imageData
  }
  return buildLegacyProcessorSrc(options)
}

export const buildLegacyProcessorSrc = (options: ILegacyImageProcessorOptions): string => {
  const {
    transparent = defaultLegacyImageProcessorOptions.transparent,
    type = defaultLegacyImageProcessorOptions.type,
  } = options
  let {
    guid = defaultLegacyImageProcessorOptions.guid,
  } = options
  if (Array.isArray(guid)) {
    guid = guid[0]
  }
  return `${environment.image.legacyApi}`
    + `?guid=${guid}`
    + `&type=${type}`
    + `&transparent=${transparent}`
}
